import { render, staticRenderFns } from "./RomaHeader.vue?vue&type=template&id=38c4c5b1"
import script from "./RomaHeader.vue?vue&type=script&lang=ts"
export * from "./RomaHeader.vue?vue&type=script&lang=ts"
import style0 from "./RomaHeader.vue?vue&type=style&index=0&id=38c4c5b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports